module.exports = __webpack_public_path__ + "static/img/hyperloop.5fa4319.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/thumbs/hyperloop.jpg
// module id = 34
// module chunks = 1